<template>
  <component
    :is="as"
    ref="boxRef"
    v-bind="$attrs"
    class="bg-white rounded-2xl"
    :class="{
      'p-6': padding === 'normal',
    }"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

interface Props {
  as?: string | Component
  padding?: 'none' | 'normal'
}

withDefaults(defineProps<Props>(), {
  as: 'div',
  padding: 'normal',
})
</script>
